module.exports = __webpack_public_path__ + "static/img/20191108.9d581c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/chanpin/20191108.png
// module id = EK5i
// module chunks = 1